module.exports = __webpack_public_path__ + "static/roca-80aa205ad71ca82cbca6d6dce16de4ca.svg";